var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "vue-modal" } }, [
    _vm.modal && _vm.modal.enabled
      ? _c("div", { staticClass: "vue-modal", class: _vm.modal.className }, [
          _c(
            "div",
            { staticClass: "vue-modal-bg", on: { click: _vm.onBgClicked } },
            [
              _c(
                "div",
                {
                  staticClass: "vue-modal-container",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c("div", { staticClass: "modal-close-btn" }, [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.onCloseBtnClicked($event)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "ion-ios-close-empty hidden-sm hidden-xs",
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass:
                            "ion-ios-arrow-thin-left visible-sm visible-xs",
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    _vm.modal.inlineComponent
                      ? _vm.modal.component
                      : _vm.modal.componentName,
                    _vm._b(
                      {
                        tag: "component",
                        on: {
                          closeModal: function ($event) {
                            _vm.closeModal($event)
                          },
                        },
                      },
                      "component",
                      _vm.modal.props || {},
                      false
                    )
                  ),
                ],
                1
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/components/VueModals/template.html?vue&type=template&id=bd6ed7e2&
// module id = 1079
// module chunks = 0